import { useState, useMemo } from 'react';
import axios from 'axios';

/**
 * Our custom React hook to manage state
 */


const useAppState = () => {
  const initialState = { 
    // ConteoSociodemografico: {},
    // Conteo_GrupoEdad: {},
    // Conteo_Rango_Ingreso: {},
    // Conteo_Sexo: {},
    // Conteo_Region: {},
    // SentimientoProm_EdadIngreso: {},
    // SentimientoProm_EdadRegion: {},
    // SentimientoProm_GrupoEdad: {},
    // SentimientoProm_Rango_Ingreso: {},
    // SentimientoProm_Region: {},
    // SentimientoProm_RegionIngreso: {},
    // SentimientoProm_Semaforo: {},
    // SentimientoProm_Sexo: {},
    // SentimientoProm_SexoEdad: {},
    // SentimientoProm_SexoIngreso: {},
    // SentimientoProm_SexoRegion: {},
    // SentimientoPromedioDiario: {},
    // TrendGeneral: {},
    // TrendSemaforo: {},
    // Trend_EdadIngreso: {},
    // Trend_EdadRegion: {},
    // Trend_GrupoEdad: {},
    // Trend_Rango_Ingreso: {},
    // Trend_Region: {},
    // Trend_RegionIngreso: {},
    // Trend_Sexo: {},
    // Trend_SexoEdad: {},
    // Trend_SexoIngreso: {},
    // Trend_SexoRegion: {},
    pagina: 'resumen'
   };

  // Manage the state using React.useState()
  const [state, setState] = useState(initialState)

  // Build our actions. We'll use useMemo() as an optimization,
  // so this will only ever be called once.
  const actions = useMemo(() => getActions(setState), [setState])

  return { state, actions }
};

// Define your actions as functions that call setState().
// It's a bit like Redux's dispatch(), but as individual
// functions.
const getActions = setState => ({
  getRegistersData: (userId, userToken) => {
    let url = `https://blooming-spire-64013.herokuapp.com/data/get_data/${userId}`
    
    let config =  { 
      headers : {
        'Content-Type' : 'application/json',
        'Accept' : 'application/json',
        'Authorization' : 'bearer ' + userToken
      }
    };
    
    axios.get(url, config, {withCredentials: true})
    .then(data => {
      localStorage.setItem('userData', JSON.stringify(data))
      setState(state => ({ ...state, data: data.data }))
    })
  },
  changeView: x => {
    switch (x) {
      case 'resumen':
        setState(state => ({ ...state, pagina: 'resumen' }));
        break;
      case 'percepcion':
        setState(state => ({ ...state, pagina: 'percepcion' }));
        break;
      case 'precio':
        setState(state => ({ ...state, pagina: 'precio' }));
        break;
      case 'tendencia':
        setState(state => ({ ...state, pagina: 'tendencia' }));
        break;
      case 'competencia':
        setState(state => ({ ...state, pagina: 'competencia' }));
        break;
      default:
        break;
    }
  },
  getCompetitorsData: (competitor_id, userToken) => {
    
    let config =  { 
      headers : {
        'Content-Type' : 'application/json',
        'Accept' : 'application/json',
        'Authorization' : 'bearer ' + userToken
      }
    };

    let url = `https://blooming-spire-64013.herokuapp.com/data/get_competitor_data/${competitor_id}`
    
    axios.get(url, config, {withCredentials: true})
    .then(data => {
      localStorage.setItem('competitorData', JSON.stringify(data.data))
      setState(state => ({ ...state, competitorsData: data.data }))
    })
  },
  // getRegistersData = (competitor_id, userToken) => {
  //   let config =  { 
  //     headers : {
  //       'Content-Type' : 'application/json',
  //       'Accept' : 'application/json',
  //       'Authorization' : 'bearer ' + userToken
  //     }
  //   };

  //   let url = `http://localhost:3000/data/get_competitor_data/${competitor_id}`
  //   axios.get(url, config, {withCredentials: true})
  //   .then(data => {
  //     // console.log(data)
  //     localStorage.setItem('competitorData', JSON.stringify(data.data))
  //     setCompetitorData({data: data.data})
  //   })
  // };
})

export default useAppState